import { getSensorColor, useScatterplotContext } from 'features/timeSeries'
import React from 'react'
import styled from 'styled-components'

const SidebarContainer = styled.div<{ $columns: number }>`
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(${({ $columns }) => $columns}, 1fr);
  grid-auto-flow: column;
  height: 10%;
  width: 100%;
  gap: 0.25rem;
  background: ${({ theme }) => theme.forecast.cardBackground};
  padding: 0.5rem;
  border-top: 4px solid ${({ theme }) => theme.forecast.cardGroupBackground};
`

const TagDescriptionsItem = styled.div<{ color: string }>`
  color: ${({ color }) => color};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 1rem;
`

export const TagDescriptionsSidebar: React.FC = () => {
  const { customSensorColors, selectedSensors } = useScatterplotContext()

  const sensorsWithDescriptions = selectedSensors.filter(
    (sensor) => sensor.data.description
  )
  const columns = Math.ceil(sensorsWithDescriptions.length / 2)

  return (
    <SidebarContainer $columns={columns}>
      {sensorsWithDescriptions.map((sensor, sensorIndex) => (
        <TagDescriptionsItem
          key={sensor.id}
          color={customSensorColors[sensor.id] || getSensorColor(sensorIndex)}>
          {sensor.data.description}
        </TagDescriptionsItem>
      ))}
    </SidebarContainer>
  )
}
